module.exports = __webpack_public_path__ + "img/loader-lightning.38fffd08.svg";